import ky from "ky";
import { PUBLIC_API_URL } from "@/constants";

const TOKEN_STORAGE_KEY = "languex_auth_token";

let authToken: string | null = null;

// Initialize token from localStorage on module load
if (typeof window !== "undefined") {
  const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (storedToken) {
    authToken = storedToken;
  }
}

export const setAuthToken = (token: string | null) => {
  authToken = token;
  
  // Persist token to localStorage
  if (typeof window !== "undefined") {
    if (token) {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    }
  }
};

export const getAuthToken = () => authToken;

export const http = ky.create({
  prefixUrl: PUBLIC_API_URL,
  timeout: false,
  hooks: {
    beforeRequest: [
      (request) => {
        // Always check for the latest token from memory or localStorage
        const token = authToken || (typeof window !== "undefined" ? localStorage.getItem(TOKEN_STORAGE_KEY) : null);
        if (token) {
          request.headers.set("Authorization", `Bearer ${token}`);
        }
      },
    ],
  },
});
